'use strict';

// For specific URLs we used in m17n site.

/**
 * Extract top and second level domain from a FQDN.
 * Neither a rigid nor a flawless helper for generic FQDN. It only work for m17n site.
 */
function extractDomain(fqdn) {
  var result = {
    firstDomainLabel: undefined, // ex: 'example' of 'example.rakuten.travel.co.jp'
    ccSLD: undefined // ex: 'co.jp' of 'example.rakuten.travel.co.jp',
    // or 'com' of 'example.rakuten.travel.com'
  };
  // m17n site has fixed 'travel.rakuten' for all served URLs.
  var matched = fqdn.match(/((.*)\.)?travel\.rakuten\.(.*)/);
  if (!matched) {
    return result;
  }
  result.firstDomainLabel = matched[2];
  result.ccSLD = matched[3];
  return result;
}

/**
 * Replace |stub| in |target| to the ccSLD extract from |fqdn|.
 * ex:
 *
 *     replaceCcSLD('www.rakuten.travel.co.jp')
 *        (':ccSLD', 'booking.rakuten.travel.:ccSLD') ->
 *     booking.rakuten.travel.co.jp
 *
 * If there is no |stub| in the |target|, it will return the original |target| w/o any change.
 * If the FQDN is without ccSLD, it will return the original |target| as well.
 */
function replaceCcSLD(fqdn) {
  var _extractDomain = extractDomain(fqdn),
      ccSLD = _extractDomain.ccSLD;

  if (typeof ccSLD === 'undefined') {
    return function (stub, target) {
      return target;
    };
  }
  return function _doReplace(stub, target) {
    return target.replace(stub, ccSLD);
  };
}

/**
 * A workaround for the in_ID issue from the API
 * @param  {String}   lang  A locale such as en_US
 * @return {Function}       A replacer function
 */
function getLangReplacer(lang) {
  if (lang !== 'id_ID') {
    return function () {
      return lang;
    };
  }

  return function (match, offset, string) {
    // for static JSON files, return id_ID
    if (string.indexOf('json') > -1) {
      return lang;
    }
    // for API, return in_ID
    return 'in_ID';
  };
}

module.exports = { extractDomain: extractDomain, replaceCcSLD: replaceCcSLD, getLangReplacer: getLangReplacer };


//////////////////
// WEBPACK FOOTER
// ./src/helpers/url.js
// module id = 1244
// module chunks = 0